module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "userinfo"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("用户名")]), _vm._v(" "), _c('span', {
    staticClass: "shenspan"
  }, [_vm._v(_vm._s(_vm.user.username))])]), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('span', {
    staticClass: "shenspan"
  }, [_vm._v(_vm._s(_vm.user.name))])]), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("联络电话")]), _vm._v(" "), _c('span', {
    staticClass: "shenspan"
  }, [_vm._v(_vm._s(_vm.user.phone))])]), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("地址")]), _vm._v(" "), _c('span', {
    staticClass: "shenspan"
  }, [_vm._v(_vm._s(_vm.user.addr))])]), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("邮箱")]), _vm._v(" "), _c('span', {
    staticClass: "shenspan"
  }, [_vm._v(_vm._s(_vm.user.email))])]), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("指导老师")]), _vm._v(" "), _c('span', {
    staticClass: "shenspan"
  }, [_vm._v(_vm._s(_vm.user.teacher))])]), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("专业")]), _vm._v(" "), _c('span', {
    staticClass: "shenspan"
  }, [_vm._v(_vm._s(_vm.user.major))])]), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("编号")]), _vm._v(" "), _c('span', {
    staticClass: "shenspan"
  }, [_vm._v(_vm._s(_vm.user.userid))])]), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("学校")]), _vm._v(" "), _c('span', {
    staticClass: "shenspan"
  }, [_vm._v(_vm._s(_vm.user.school))])]), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("学校所在省份")]), _vm._v(" "), _c('span', {
    staticClass: "shenspan"
  }, [_vm._v(_vm._s(_vm.user.province))])]), _vm._v(" "), _c('div', {
    staticClass: "rowinfo"
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("个人生活照")]), _vm._v(" "), (_vm.user.avatar_url != '') ? _c('span', {
    staticClass: "shenspan"
  }, [_c('img', {
    attrs: {
      "src": _vm.url + '/assets/upload/' + _vm.user.avatar_url
    }
  })]) : _c('span', {
    staticClass: "shenspan"
  }, [_vm._v("无")])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "black",
      "padding-bottom": "10px",
      "font-size": "14px",
      "border-bottom": "1px solid #f2f6fa",
      "margin-bottom": "20px"
    }
  }, [_vm._v("账号安全")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-bottom": "60px"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "changePwd",
    staticStyle: {
      "position": "relative",
      "top": "-40px",
      "left": "800px"
    },
    on: {
      "click": _vm.changePwd
    }
  }, [_vm._v("修改密码")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title_wrap"
  }, [_c('span', {
    staticClass: "title_name"
  }, [_vm._v("资料与账号")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subtitle_wrap"
  }, [_c('span', {
    staticClass: "subtitle"
  }, [_vm._v("基本信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "changeInfo",
    staticStyle: {
      "position": "relative",
      "left": "800px",
      "top": "-60px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/changeInfo"
    }
  }, [_vm._v("修改基本信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "40",
      "line-height": "40px",
      "color": "black",
      "font-size": "12px"
    }
  }, [_c('span', {
    staticClass: "fadespan"
  }, [_vm._v("登陆密码")]), _c('span', {
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_vm._v("密码建议包含字母，符号或数字中的两项且长度超过8位，以保证账号更加安全。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6062e9c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User.vue
// module id = 622
// module chunks = 1